import { useEffect, useState } from 'react'

/**
 * Returns a debounced copy of `value`. The returned value only updates
 * after `delayMs` has passed without a new change. Used to throttle
 * keystroke-driven API calls (e.g. autocomplete) so we don't fire a
 * request on every character.
 */
export function useDebounce<T>(value: T, delayMs: number = 250): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debouncedValue
}
